// FLAGS: authorization
// The one role test in the app — every gate that mentions CustomerSuccess calls this.
import { UserProfile, OpenUpRole } from "@src/models/auth";

// FLAGS: authorization
// Accepts both the integer wire value and the name because the API serializes roles as integers.
// Narrowing it to either form alone denies every real CS account, with no error raised anywhere.
const isCustomerSuccess = (user: UserProfile | null | undefined): boolean =>
  user?.roles?.some(
    (role) => role === OpenUpRole.CustomerSuccess || role === "CustomerSuccess",
  ) ?? false;

export default isCustomerSuccess;
